/**
 * Created by Mark on 04/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link , hashHistory } from "react-router";
import Chat from '../../classes/chat_client.js';
import ProductStore from '../../store/product-store.js';
import { Row , Col , OverlayTrigger , Tooltip , Button , Modal } from 'react-bootstrap';
import CDNImage from '../../components/media/image.js';
import MedalGraphic from '../../components/media/medal.image.js';
import MedalsService from '../../services/medals-service.js';
import WordsLearntService from '../../services/wordslearnt-services.js';
import MedalStore from '../../store/medals-store.js';
import WordsLearntStore from '../../store/words-learnt-store.js';
import InternationalizationStore from '../../store/internationalization-store.js';

export default class Header extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            'onSearch': props.onSearch,
            'blurSearch':props.blurSearch,
            'body' : this.props.body || '',
            'brand': this.props.brand || 'Languagenut',
            'menuToggled':this.props.toggle,
            'searchToggled':false,
            'handelToggle':this.props.handelToggle,
            gold:0,
            silver:0,
            bronze:0,
            totalWords:0,
            schoolName:"Languagenut School",
            showLogout:false
        }
    }

    componentDidMount(){
        MedalsService.getAccountsMedals();
        WordsLearntService.getTotal();
    }

    componentWillMount(){
        document.getElementsByTagName("body")[0].setAttribute("data-ma-header", "brand");

        MedalStore.on("CHANGE" , () => {
            this.setState({
                gold:MedalStore.getAccountGold(),
                silver:MedalStore.getAccountSilver(),
                bronze:MedalStore.getAccountBronze(),
            });
        });

        WordsLearntStore.on("CHANGE" , () => {
            this.setState({
                totalWords:WordsLearntStore.getAccountTotal()
            });
        });
    }

    componentWillReceiveProps(props){
        this.setState({menuToggled:props.toggle})
    }

    handelSearchFocus(bool){

        if(bool === false) this.state.blurSearch();

        this.search.value = '';
        this.setState({searchToggled: bool});
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.state.onSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelChatToggel(){
        (new Chat()).toggleChatClient();
    }
    handelJumpto(){

        if(sessionStorage.getItem('product') == "huber" || sessionStorage.getItem("product") == "klett" ||
            sessionStorage.getItem('product') == "larousse" || sessionStorage.getItem('product') == "hodder" ||
            sessionStorage.getItem('product') == "cornelson")
        {
            return window.location.href = window.location.origin + "/resources/#/Curriculum";
        }

        window.location.href = window.location.origin + "/resources";
    }

    handelJumptoHome(){
        window.open('pdf/'+InternationalizationStore.getInstructionsPDF());
    }


    handelLogout(){
        sessionStorage.clear();
        window.location.href = window.location.origin + "/resources/#/LoginScreen";
    }


    renderBadge(icon , text , number){
        return <div className="ca-item media">
            <div className="pull-right hidden-xs hidden-sm hidden-md">
                {icon}
            </div>
            <div className="media-body palette-Branding primary text">
                <h2 className="palette-Branding primary text">{text}</h2>
                <small className="palette-Branding secondary text">
                    {number}
                </small>
            </div>
        </div>
    }

    renderHeader(){

        return  [
                    <Col sm={3} >{this.renderBadge(<CDNImage className="p-t-10" size={50} src="img/new/dashboard/graph.png"/> , this.state.totalWords || 0 ,  <FormattedMessage id={ 'ui-813' } defaultMessage={ 'Words Learnt' }/>)}</Col>,
                    <Col sm={3}>{this.renderBadge(<MedalGraphic size={50} medal="gold"/> , this.state.gold ,  <FormattedMessage id={ 'ui-271' } defaultMessage={ 'Total Gold' }/>)}</Col>,
                    <Col sm={3}>{this.renderBadge(<MedalGraphic size={50} medal="silver"/> , this.state.silver ,  <FormattedMessage id={ 'ui-270' } defaultMessage={ 'Total Silver' }/>)}</Col>,
                    <Col sm={3}>{this.renderBadge(<MedalGraphic size={50} medal="bronze"/> , this.state.bronze ,  <FormattedMessage id={ 'ui-269' } defaultMessage={ 'Total Bronze' }/>)}</Col>
]
    }

    toggleLogout(){
        this.setState({showLogout:!this.state.showLogout})
    }
    render(){

        let Chat = null;

        if(sessionStorage.getItem("product") == "languagenut")
        {
            Chat =
                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-885' } defaultMessage={ 'Chat' }/></Tooltip>}>
                    <li className="hm-alerts" data-user-alert="sua-messages" data-ma-action="sidebar-open" data-ma-target="user-alerts">
                        <a onClick={this.handelChatToggel}><i className="hm-icon zmdi zmdi zmdi-email"></i></a>
                    </li>
                </OverlayTrigger>
        }


        return (
            <header id="header" className="media">
                <Modal show={this.state.showLogout} onHide={this.toggleLogout.bind(this)}>
                    <Modal.Header>
                        <Modal.Title><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Edit' }/></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <FormattedMessage id={ 'ui-223' } defaultMessage={ 'No MSG' }/>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.toggleLogout.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancle' }/></Button>
                        <Button onClick={this.handelLogout.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Save' }/></Button>
                    </Modal.Footer>

                </Modal>
                <Row>
                    <Col sm={1} md={1} lg={2}>
                        <div className="pull-left h-logo">
                            <div onClick={ this.state.handelToggle } className={ (this.state.menuToggled === true ? 'toggled ' : '' ) + "menu-collapse" }>
                                <div className="mc-wrap">
                                    <div className="mcw-line top palette-Branding primary bg"></div>
                                    <div className="mcw-line center palette-Branding primary bg"></div>
                                    <div className="mcw-line bottom palette-Branding primary bg"></div>
                                </div>
                            </div>
                            <a className="hidden-xs hidden-sm hidden-md palette-Branding primary text">
                                <img src={ProductStore.getLogo()}></img>
                                <small className="subTitle text-right hidden-xs palette-Branding secondary text"><FormattedMessage id={ 'ui-91' } defaultMessage={ 'Admin Area' } /></small>
                            </a>
                        </div>
                    </Col>
                    <Col sm={8} md={8} lg={10} className="hidden-xs ">
                        <Row>
                            {this.renderHeader()}
                        </Row>
                    </Col>
                    <Col sm={3} md={3} className="hidden-lg">
                        <ul className="pull-right h-menu">
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-793' } defaultMessage={ 'Chat' }/></Tooltip>}>
                                <li className="hm-alerts" onClick={this.handelJumptoHome}>
                                    <a><i  className="hm-icon palette-Branding  text zmdi zmdi-help"></i></a>
                                </li>
                            </OverlayTrigger>
                            {Chat}
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-460' } defaultMessage={ 'Jump to resources' }/></Tooltip>}>
                                <li  className="hm-alerts" onClick={this.handelJumpto}>
                                    <a><i className="hm-icon palette-Branding  text zmdi zmdi-library"></i></a>
                                </li>
                            </OverlayTrigger>

                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-40' } defaultMessage={ 'Logout' }/></Tooltip>}>
                                <li  className="hm-alerts" onClick={this.toggleLogout.bind(this)}>
                                    <a><i className="hm-icon palette-Branding  text zmdi zmdi-power"></i></a>
                                </li>
                            </OverlayTrigger>
                        </ul>
                    </Col>
                </Row>
            </header>
        );


    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/standard-page-header.js